import { type FC } from 'react'
import { Modal } from '../../../components/Modal/Modal'

interface EventTypeNotLiveDialogProps {
  onContinue: () => void
  onCancel: () => void
}

export const EventTypeNotLiveDialog: FC<EventTypeNotLiveDialogProps> = ({ onContinue, onCancel }) => (
  <Modal
    show
    onHide={onCancel}
    header={<h5 className='mb-0'>This event type won&apos;t be live yet</h5>}
    headerBodySeparator
    body={
      <span className='paragraph-medium'>
        Clients can&apos;t book it on the <span className='bold'>account booking page</span> until you choose who takes its bookings.
      </span>
    }
    showFooterActions
    footerPrimaryActionTitle='Set hosts'
    footerSecondaryActionTitle='Cancel'
    onFooterPrimaryAction={onContinue}
    onFooterSecondaryAction={onCancel}
  />
)
